module.exports = __webpack_public_path__ + "static/media/7-monkeys.37e23710.gif";